import { Component, OnInit, ViewChild, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { FileUploadService } from '@app/services/fileUpload.service';
import { FileUpload } from '@app/model/fileUpload';
import { MessageService } from 'primeng/api';
import { Applicant } from '@app/model/applicant';
import { ApplicantDocument } from '@app/model/applicantDocument';
import { ApplicantDocumentService } from '@app/services/applicantDocument.service';
import { NgForm } from '@angular/forms';
import { Messages } from '@app/constants/constant';
import { ApplicantService } from '@app/services/applicant.service';
import { JsonPipe } from '@angular/common';
import { debug } from 'util';
import { QueryOptions } from '@app/model/query-options';
import { CommonService } from '@app/services/common.service';
import { RecruiterService } from '@app/services/recruiterService';
import { environment } from '@environments/environment';
import { HttpClient } from '@angular/common/http';



@Component({
  selector: 'app-applicant-creation',
  templateUrl: './applicant-creation.component.html',
  styleUrls: ['./applicant-creation.component.css']
})
export class ApplicantCreationComponent implements OnInit {


  pageSize: number = 500;
  first: number = 0;
  candidateName: string;
  mobileNumber: string;
  currentCtc: string;
  alternateMobileNumber :string;
  remark:string;
  currentTitle: string;
  candidateCV: string;
  emailId: string;
  currentBonus: string;
  uploadedFile: File;
  uploadedFiles: any[] = [];
  form: object = {};
  showCrossIcon=true;
  newApplicant: Applicant;
  newUploadedFile: FileUpload;//represents the newly uploaded file entity
  showUploadError:boolean=false;
  candidateFirstName: any;
  candidateLastName :any;
  editApplicant:Applicant;
  fileUrl: string;
  sourceTypeOptions:any;
  sourceNameOptions: any;
  sourceType: any;
  isDuplicate:boolean=false;
  phone: string;
  email: string;

  showCloseIcon(){
    this.showCrossIcon=false
  };
  @Input() display: boolean;
  @Output() displayFunction = new EventEmitter<boolean>();
  @Output() applicantData = new EventEmitter<Object>();
  @Input() searchedApplicant :any;
  editApplicantFlag :boolean;
  source :any;
  referredById:any;
  @ViewChild('createApplicantForm', { static: false }) public createApplicantForm: NgForm;
  appCreation: {id:string; firstName: string; lastName: string; email: string; currentCtc: string;
     currentTitle: string; currentBonus: string; phone: string; candidateCV: string;alternatePhone :string ;resumeFileName:string;remark :string;
     candidateCVFileName :string;resumeUrl:string; sourceType:any;sourceName:any;};

  constructor(private _fileUploadService: FileUploadService,
    private _toastService: MessageService,
    private _applicantDocumentService: ApplicantDocumentService, private _applicantService: ApplicantService,
    private _commonService :CommonService,
    private http: HttpClient,
    private _recruiterService: RecruiterService,) { }

  ngOnInit() {
    this.appCreation = { 
      id:"",
      firstName: "",
      lastName :"",
      email: "",
      currentCtc: "",
      currentTitle: "",
      currentBonus: "",
      phone: "",
      candidateCV: "",
      alternatePhone :"",
      remark :"",
      candidateCVFileName :"",
      resumeFileName :"",
      resumeUrl:"",
      sourceType:"",
      sourceName :"",
    };
    this._commonService.list(this.queryParams("name"),'source-type').subscribe(res => {
    this.sourceTypeOptions= res;
    });
    this.editApplicantFlag= this.display && this.searchedApplicant? true:false;
    if(this.editApplicantFlag){this.updateApplicantForm(this.searchedApplicant)}
  }

  queryParams(sortField){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField: sortField, sortOrder: 1 };
    queryParams['pageParam'] = {
    page:
        this.first / this.pageSize > 1
        ? this.first / this.pageSize + 1
         : this.first / this.pageSize,
      size: this.pageSize
    };
    const dropDownSortingQueryOptions = new QueryOptions(queryParams);
    dropDownSortingQueryOptions.toQueryMap();
    return dropDownSortingQueryOptions;
}
  // ngOnChanges(changes: SimpleChanges) {
  //   for (let propName in changes) {  
  //     if (propName == "display"){
  //       let change= changes[propName];
  //       if(JSON.stringify(change.currentValue)=="true" && this.searchedApplicant){
  //         this.editApplicantFlag=true;
  //         this.updateApplicantForm(this.searchedApplicant);
  //       }
  //     }
  // }
  // }

  updateApplicantForm(applicant){
    this.appCreation.id =applicant.id;
    this.appCreation.firstName=applicant.firstName;
    this.appCreation.lastName=applicant.lastName;
    this.appCreation.email=applicant.email;
    this.appCreation.phone=applicant.phone;
    this.appCreation.alternatePhone=applicant.alternatePhone;
    this.appCreation.currentTitle=applicant.currentTitle;
    this.appCreation.currentBonus=applicant.bonus;
    this.appCreation.remark=applicant.remarks;
    this.appCreation.currentCtc=applicant.currentCtc;
    this.appCreation.candidateCVFileName=applicant.resumeFileName;
    this.appCreation.resumeUrl=applicant.resumeUrl;
    this.fileUrl=Messages.endpoint.fileUrlDomain + applicant.resumeUrl;
    if(applicant.source){
    this.appCreation.sourceType={label:applicant.source.sourceType.name,id:applicant.source.sourceType.id};
    this.updateSource(applicant.source.sourceType);
    this.appCreation.sourceName={sourceName:applicant['source']['sourceName'],id:applicant['source']['id']};
    }
    else if(applicant.referredBy){
      this.appCreation.sourceType={sourceName:applicant['sourceType']['name'],id:applicant['sourceType']['id']};
      this.updateSource(applicant['sourceType']);
      this.appCreation.sourceName={label:applicant['referredBy']['lastName']?applicant['referredBy']['firstName']+" "+ applicant['referredBy']['lastName']: applicant['referredBy']['firstName'],id:applicant['referredBy']['id']};
    }
    
  }
 
  updateSource(sourceType){
    var endpointSource="source/sourceType/"+sourceType.id;
    this._commonService.list(this.queryParams("sourceName"),endpointSource,undefined,Messages.endpoint.sourceNameParams).subscribe(res => {
      this.sourceNameOptions= res;
    });
  }

  onSelect(event,fileUpload) {
    //this.uploadedFiles = event.file;
    this.uploadedFile = event.files[0];
    this.appCreation.candidateCVFileName=event.files[0].name;
    //this.uploadedFile = event.files[0];
    if(this.uploadedFile==undefined){
      this.showUploadError=true;
    }else{
      this.showUploadError=false;
    }
    fileUpload.clear();
  }
  onBasicUpload(event) {
   this.uploadedFile = event.file;
  }
  showDialog(bool: boolean) {
    this.displayFunction.emit(bool);
  }


  createApplicant(createApplicantForm) {
    this.candidateFirstName =this.createApplicantForm.value.candidateFirstName ? this.createApplicantForm.value.candidateFirstName : '';
    this.candidateLastName = this.createApplicantForm.value.candidateLastName? this.createApplicantForm.value.candidateLastName: '';
    this.currentBonus = this.createApplicantForm.value.currentBonus ? this.createApplicantForm.value.currentBonus : '';
    this.currentCtc = this.createApplicantForm.value.currentCtc ? this.createApplicantForm.value.currentCtc : '';
    this.currentTitle = this.createApplicantForm.value.currentTitle ? this.createApplicantForm.value.currentTitle : '';
    this.emailId = this.createApplicantForm.value.emailId ? this.createApplicantForm.value.emailId : '';
    this.mobileNumber = this.createApplicantForm.value.mobileNumber ? this.createApplicantForm.value.mobileNumber : '';
    this.alternateMobileNumber= this.createApplicantForm.value.alternateMobileNumber ? this.createApplicantForm.value.alternateMobileNumber : '';
    this.remark=this.createApplicantForm.value.remark?this.createApplicantForm.value.remark :'';
    this.sourceType=this.createApplicantForm.value.sourceType ? this.createApplicantForm.value.sourceType :'';
    this.source=this.createApplicantForm.value.sourceName ? this.createApplicantForm.value.sourceName.id :'';
    
    if(this.editApplicantFlag){
      let app = new Applicant();
      app.firstName = this.candidateFirstName;
      app.lastName= this.candidateLastName;
      app.email = this.emailId;
      app.phone = this.mobileNumber;
      app.currentCtc = this.currentCtc;
      app.currentTitle = this.currentTitle;
      app.bonus = this.currentBonus;
      app.alternatePhone=this.alternateMobileNumber;
      app.remarks=this.remark;
      if(this.sourceType.id==Messages.employeeReferalId){
        app.referredById=this.source;}
        else{
        app.sourceId=this.source;}

      if(this.uploadedFile){
        this._fileUploadService.createFile(this.uploadedFile).subscribe(
          res => {
          
           this.newUploadedFile = res;
           // app.resumeUrl= this.newUploadedFile.id ;
            this._applicantService.read(this.appCreation.id,Messages.endpoint.applicant).subscribe(res=>{
              app.id=res.id;
            this._applicantService.update(app).subscribe(res=>{
              this.newApplicant=res;
              let appdoc = new ApplicantDocument();
               appdoc.file = this.newUploadedFile.id;
              this._applicantDocumentService.read(this.newApplicant.id,Messages.endpoint.applicantDocument_applicant).subscribe(res=>{
            appdoc.applicant=res.applicant;
            appdoc.id=res.id;
            this._applicantDocumentService.update(appdoc,Messages.endpoint.applicantDocument).subscribe(res=>{
              this.newApplicant.resumeUrl=this.newUploadedFile.id;
              this.newApplicant.resumeFileName=this.newUploadedFile.originalFileName;
              this.applicantData.emit(this.newApplicant);
              this.showApplicantToast();
              this.showDialog(false);
              this.createApplicantForm.reset();
            },(err)=>{
              this.showApplicantToastError();
              this.showDialog(false);
              this.createApplicantForm.reset();
            })
          })
            })
          });});
      }
      else{
        this._applicantService.read(this.appCreation.id,Messages.endpoint.applicant).subscribe(res=>{
        //  app.resumeUrl= res.resumeUrl;
          app.id=res.id;
          this._applicantService.update(app).subscribe(res=>{
            this.showApplicantToast();
              this.applicantData.emit(res);
              this.showDialog(false);
              this.createApplicantForm.reset();
          }, (err) => { 
            this.showApplicantToastError();
            this.showDialog(false);
            this.createApplicantForm.reset();
            })
         })
      }
    }
    else{
      if(this.uploadedFile===undefined){
        this.showUploadError=true;
      }
      else{
    //here we are going to create create the entry of this file into the database also applicant entry in database.
    // the file upload id and applicant id is then used to create applicant document 
    this._fileUploadService.createFile(this.uploadedFile).subscribe(
      res => {
       this.newUploadedFile = res;
        let app = new Applicant();
        app.firstName = this.candidateFirstName;
        app.lastName= this.candidateLastName;
        app.email = this.emailId;
        app.phone = this.mobileNumber;
        app.currentCtc = this.currentCtc;
        app.currentTitle = this.currentTitle;
        app.bonus = this.currentBonus;
        app.resumeUrl=this.newUploadedFile.id;
        app.alternatePhone=this.alternateMobileNumber;
        app.remarks=this.remark;
        if(this.sourceType.id==Messages.employeeReferalId){
        app.referredById=this.source;}
        else{
        app.sourceId=this.source;}

        this._applicantService.create(app,Messages.endpoint.applicant).subscribe(res => {
          this.newApplicant = res;
          this.newApplicant.sourceType=this.sourceType;
          let appdoc = new ApplicantDocument();
          appdoc.applicant = this.newApplicant.id;
          appdoc.file = this.newUploadedFile.id;
          this.newApplicant.resumeUrl=this.newUploadedFile.id;
          this.newApplicant.resumeFileName=this.newUploadedFile.originalFileName;
          this._applicantDocumentService.create(appdoc,Messages.endpoint.applicantDocument).subscribe(
            res => {
              this.showApplicantToast(); 
              this.applicantData.emit(this.newApplicant);
              this.showDialog(false);
              this.createApplicantForm.reset();
            }
          );
        }, (err) => { this._toastService.add({ 
        severity: 'error',
        summary: Messages.applicantCreatedError, 
        detail: Messages.alreadyRegisteredApplicant });
        this.showDialog(false);
        this.createApplicantForm.reset();
        }
        );

      }, (err) => { 
       this.showApplicantToastError();
       this.showDialog(false);
       this.createApplicantForm.reset();
       }
    );
  }}
}

showApplicantToast = function () {
  this._toastService.add({ severity: 'success', summary:this.editApplicantFlag ? Messages.applicantEdited: Messages.applicantCreatedSuccess, detail: '' });}

showApplicantToastError =function () {
  this._toastService.add({ severity: 'error', summary:this.editApplicantFlag ? 'Applicant cannot be edited': Messages.applicantCreatedError, detail: '' });
}

checkDuplicateCandidate =function () {
  console.log(this.appCreation.phone);
  console.log(this.appCreation.email);
  if(!this.appCreation.phone || !this.appCreation.email){
  return ;
}
let duplicate = {
  phone : this.appCreation.phone,
  email : this.appCreation.email
  }
  console.log(duplicate);
  this.http.post(environment.apiUrl+"/applicant/duplicate",duplicate).subscribe(res=>{
    //this.spinner.hide();
    console.log(res);
   if (res == 1) {
     this.isDuplicate = true
     console.log("exist");
     console.log(this.isDuplicate);
     console.warn(this.editApplicantFlag)
      }  
      else {
    this.isDuplicate = false
    console.log("not exist");
   }
});
}
setIsDuplicate(){
  this.isDuplicate=false;
}

}
